const jobs = [
  {
    nombre_profesion: "Abogado",
  },
  {
    nombre_profesion: "Actor",
  },
  {
    nombre_profesion: "Actuario",
  },
  {
    nombre_profesion: "Administrador de Redes Informáticos",
  },
  {
    nombre_profesion: "Agente de seguros",
  },
  {
    nombre_profesion: "Agente inmobiliario",
  },
  {
    nombre_profesion: "Albañil",
  },
  {
    nombre_profesion: "Analista de Investigación de Mercados",
  },
  {
    nombre_profesion: "Analista de Seguridad de la Información",
  },
  {
    nombre_profesion: "Analista Financiero",
  },
  {
    nombre_profesion: "Analista Sistemas Informáticos",
  },
  {
    nombre_profesion: "Arqueólogo",
  },
  {
    nombre_profesion: "Arquitecto",
  },
  {
    nombre_profesion: "Artista Multimedia",
  },
  {
    nombre_profesion: "Asesor genético",
  },
  {
    nombre_profesion: "Asistente de Enfermería",
  },
  {
    nombre_profesion: "Asistente de Enseñanza",
  },
  {
    nombre_profesion: "Asistente de Terapia Ocupacional",
  },
  {
    nombre_profesion: "Asistente Médico",
  },
  {
    nombre_profesion: "Autor",
  },
  {
    nombre_profesion: "Auxiliar de enfermería",
  },
  {
    nombre_profesion: "Auxiliar de vuelo",
  },
  {
    nombre_profesion: "Ayudante de Cuidado Personal",
  },
  {
    nombre_profesion: "Ayudante de Salud en el Hogar",
  },
  {
    nombre_profesion: "Bibliotecario",
  },
  {
    nombre_profesion: "Biólogo",
  },
  {
    nombre_profesion: "Bombero",
  },
  {
    nombre_profesion: "Bróker de bolsa",
  },
  {
    nombre_profesion: "Cajero",
  },
  {
    nombre_profesion: "Cajero financiero",
  },
  {
    nombre_profesion: "Camarero",
  },
  {
    nombre_profesion: "Carnicero",
  },
  {
    nombre_profesion: "Carpintero",
  },
  {
    nombre_profesion: "Cartero de correo",
  },
  {
    nombre_profesion: "Cartógrafo",
  },
  {
    nombre_profesion: "Catedrático",
  },
  {
    nombre_profesion: "Chef",
  },
  {
    nombre_profesion: "Científico Agrónomo",
  },
  {
    nombre_profesion: "Científico de datos",
  },
  {
    nombre_profesion: "Cirujano",
  },
  {
    nombre_profesion: "Clero",
  },
  {
    nombre_profesion: "Comprador",
  },
  {
    nombre_profesion: "Conductor de autobús",
  },
  {
    nombre_profesion: "Conductor de camiones",
  },
  {
    nombre_profesion: "Consejero vocacional",
  },
  {
    nombre_profesion: "Conserje",
  },
  {
    nombre_profesion: "Conservador del Museo",
  },
  {
    nombre_profesion: "Contador",
  },
  {
    nombre_profesion: "Controlador de tráfico aéreo",
  },
  {
    nombre_profesion: "Coordinadora de Eventos",
  },
  {
    nombre_profesion: "Coreógrafo",
  },
  {
    nombre_profesion: "Costurera",
  },
  {
    nombre_profesion: "Cristalero",
  },
  {
    nombre_profesion: "Dentista",
  },
  {
    nombre_profesion: "Desarrollador de software",
  },
  {
    nombre_profesion: "Desarrollador Web",
  },
  {
    nombre_profesion: "Diagnóstico Médico Sonógrafo",
  },
  {
    nombre_profesion: "Dietista",
  },
  {
    nombre_profesion: "Directivo senior",
  },
  {
    nombre_profesion: "Director de colegio",
  },
  {
    nombre_profesion: "Director de funeraria",
  },
  {
    nombre_profesion: "Disc Jockey",
  },
  {
    nombre_profesion: "Diseñador de Moda",
  },
  {
    nombre_profesion: "Diseñador Industrial",
  },
  {
    nombre_profesion: "Economista",
  },
  {
    nombre_profesion: "Editor de publicaciones",
  },
  {
    nombre_profesion: "Ejecutivo de cuentas de publicidad",
  },
  {
    nombre_profesion: "Ejecutivo de Relaciones Públicas",
  },
  {
    nombre_profesion: "Electricista",
  },
  {
    nombre_profesion: "Emisora",
  },
  {
    nombre_profesion: "Empleada doméstica",
  },
  {
    nombre_profesion: "Empleado de envío y recepción",
  },
  {
    nombre_profesion: "Enfermera Practicante",
  },
  {
    nombre_profesion: "Enfermera Registrada",
  },
  {
    nombre_profesion: "Ensamblador de automóviles",
  },
  {
    nombre_profesion: "Ensamblador de precisión",
  },
  {
    nombre_profesion: "Entrenador de fitness",
  },
  {
    nombre_profesion: "Especialista en Capacitación y Desarrollo",
  },
  {
    nombre_profesion: "Especialista en soporte informático",
  },
  {
    nombre_profesion: "Estadístico",
  },
  {
    nombre_profesion: "Estilista",
  },
  {
    nombre_profesion: "Examinador de Impuestos",
  },
  {
    nombre_profesion: "Farmacéutico",
  },
  {
    nombre_profesion: "Ferretero",
  },
  {
    nombre_profesion: "Físico",
  },
  {
    nombre_profesion: "Fotógrafo",
  },
  {
    nombre_profesion: "Geólogo",
  },
  {
    nombre_profesion: "Gerente de Alojamiento",
  },
  {
    nombre_profesion: "Gerente de Compras",
  },
  {
    nombre_profesion: "Gerente de Construcción",
  },
  {
    nombre_profesion: "Gerente de Medios Sociales",
  },
  {
    nombre_profesion: "Gerente de Recursos Humanos",
  },
  {
    nombre_profesion: "Gerente de Sostenibilidad",
  },
  {
    nombre_profesion: "Gerente de ventas digital",
  },
  {
    nombre_profesion: "Gerente Social y Comunitario",
  },
  {
    nombre_profesion: "Granjero",
  },
  {
    nombre_profesion: "Guardia de seguridad",
  },
  {
    nombre_profesion: "Higienista dental",
  },
  {
    nombre_profesion: "Historiador",
  },
  {
    nombre_profesion: "Ingeniero Aeroespacial",
  },
  {
    nombre_profesion: "Ingeniero Ambiental",
  },
  {
    nombre_profesion: "Ingeniero Civil",
  },
  {
    nombre_profesion: "Ingeniero de Petróleo",
  },
  {
    nombre_profesion: "Ingeniero Eléctrico",
  },
  {
    nombre_profesion: "Ingeniero Industrial",
  },
  {
    nombre_profesion: "Ingeniero Mecánico",
  },
  {
    nombre_profesion: "Ingeniero Nuclear",
  },
  {
    nombre_profesion: "Ingeniero Técnico",
  },
  {
    nombre_profesion: "Inspector de Edificios",
  },
  {
    nombre_profesion: "Inspector de Incendios",
  },
  {
    nombre_profesion: "Inspector de Incendios Forestales",
  },
  {
    nombre_profesion: "Instalador de alfombras",
  },
  {
    nombre_profesion: "Instalador Solar Fotovoltaico",
  },
  {
    nombre_profesion: "Joyero",
  },
  {
    nombre_profesion: "Juez",
  },
  {
    nombre_profesion: "Lavaplatos",
  },
  {
    nombre_profesion: "Leñador",
  },
  {
    nombre_profesion: "Logista",
  },
  {
    nombre_profesion: "Logopeda",
  },
  {
    nombre_profesion: "Maestra de Escuela Primaria",
  },
  {
    nombre_profesion: "Maquinista",
  },
  {
    nombre_profesion: "Matemático",
  },
  {
    nombre_profesion: "Mecánico de aeronaves",
  },
  {
    nombre_profesion: "Mecánico de automóviles",
  },
  {
    nombre_profesion: "Mecánico de equipos de comunicación",
  },
  {
    nombre_profesion: "Médico",
  },
  {
    nombre_profesion: "Meteorólogo",
  },
  {
    nombre_profesion: "Militar",
  },
  {
    nombre_profesion: "Obrero de construcción",
  },
  {
    nombre_profesion: "Oficial penitenciario",
  },
  {
    nombre_profesion: "Operador de carretilla elevadora",
  },
  {
    nombre_profesion: "Operador de maquinaria de construcción",
  },
  {
    nombre_profesion: "Operador de planta de aguas residuales",
  },
  {
    nombre_profesion: "Óptico",
  },
  {
    nombre_profesion: "Optometrista",
  },
  {
    nombre_profesion: "Ortodoncista",
  },
  {
    nombre_profesion: "Periodista prensa",
  },
  {
    nombre_profesion: "Piloto de aerolínea",
  },
  {
    nombre_profesion: "Pintor",
  },
  {
    nombre_profesion: "Plomero",
  },
  {
    nombre_profesion: "Podólogo",
  },
  {
    nombre_profesion: "Policía",
  },
  {
    nombre_profesion: "Preparador de Impuestos",
  },
  {
    nombre_profesion: "Procesador de texto",
  },
  {
    nombre_profesion: "Programador computacional",
  },
  {
    nombre_profesion: "Psicólogo",
  },
  {
    nombre_profesion: "Psiquiatra",
  },
  {
    nombre_profesion: "Químico",
  },
  {
    nombre_profesion: "Quiropráctico",
  },
  {
    nombre_profesion: "Radioterapeuta",
  },
  {
    nombre_profesion: "Recaudación de fondos",
  },
  {
    nombre_profesion: "Recepcionista",
  },
  {
    nombre_profesion: "Reclutador",
  },
  {
    nombre_profesion: "Recolector de basura",
  },
  {
    nombre_profesion: "Redactor Técnico",
  },
  {
    nombre_profesion: "Reparador de bicicletas",
  },
  {
    nombre_profesion: "Reparador de carrocerías de automóviles",
  },
  {
    nombre_profesion: "Reparador de electrodomésticos",
  },
  {
    nombre_profesion: "Reparador de equipos eléctricos",
  },
  {
    nombre_profesion: "Reparador de máquinas industriales",
  },
  {
    nombre_profesion: "Representante de ventas al por mayor y de fabricación",
  },
  {
    nombre_profesion: "Secretario Médico",
  },
  {
    nombre_profesion: "Servidor de comida",
  },
  {
    nombre_profesion: "Sociólogo",
  },
  {
    nombre_profesion: "Soldador",
  },
  {
    nombre_profesion: "Tapicero de muebles",
  },
  {
    nombre_profesion: "Taquígrafo",
  },
  {
    nombre_profesion: "Taxista",
  },
  {
    nombre_profesion: "Techador",
  },
  {
    nombre_profesion: "Técnico de laboratorio dental",
  },
  {
    nombre_profesion: "Técnico de laboratorio médico",
  },
  {
    nombre_profesion: "Técnico de radiodifusión",
  },
  {
    nombre_profesion: "Técnico Eléctrico",
  },
  {
    nombre_profesion: "Técnico en Ciencias Forenses",
  },
  {
    nombre_profesion: "Técnico en descontaminación nuclear",
  },
  {
    nombre_profesion: "Técnico en turbinas eólicas",
  },
  {
    nombre_profesion: "Técnico Farmacéutico",
  },
  {
    nombre_profesion: "Técnico médico de emergencias",
  },
  {
    nombre_profesion: "Técnico Veterinario",
  },
  {
    nombre_profesion: "Tecnólogo médico",
  },
  {
    nombre_profesion: "Terapeuta de Masaje",
  },
  {
    nombre_profesion: "Terapeuta Físico",
  },
  {
    nombre_profesion: "Terapeuta ocupacional",
  },
  {
    nombre_profesion: "Topógrafo",
  },
  {
    nombre_profesion: "Trabajador de Control de Plagas",
  },
  {
    nombre_profesion: "Trabajador de cuidado de niños",
  },
  {
    nombre_profesion: "Trabajador de Cuidado y Servicio de Animales",
  },
  {
    nombre_profesion: "Trabajador de la chapa metálica",
  },
  {
    nombre_profesion: "Trabajador de la plataforma petrolífera",
  },
  {
    nombre_profesion: "Trabajador de Recreación",
  },
  {
    nombre_profesion: "Trabajador de Transporte Acuático",
  },
  {
    nombre_profesion: "Trabajador portuario",
  },
  {
    nombre_profesion: "Trabajador Social",
  },
  {
    nombre_profesion: "Traductor",
  },
  {
    nombre_profesion: "Vendedor de publicidad",
  },
  {
    nombre_profesion: "Vendedor minorista",
  },
  {
    nombre_profesion: "Veterinario",
  },
  {
    nombre_profesion: "Zoólogo",
  },
];
export default jobs;
